import { apiUrl } from '../config/api'

function getAuthHeader() {
    const secret = localStorage.getItem('x-auth-secret')
    return secret ? { 'x-auth-secret': secret } : {}
}

export async function listGeneralConfigs() {
    const resp = await fetch(apiUrl('/api/admin/general-config'), {
        headers: { ...getAuthHeader(), 'Accept': 'application/json' }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to fetch configs')
    return resp.json()
}

export async function createGeneralConfig(body) {
    const resp = await fetch(apiUrl('/api/admin/general-config'), {
        method: 'POST',
        headers: { ...getAuthHeader(), 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to create config')
    return resp.json()
}

export async function updateGeneralConfig(id, body) {
    const resp = await fetch(apiUrl(`/api/admin/general-config/${id}`), {
        method: 'PUT',
        headers: { ...getAuthHeader(), 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to update config')
    return resp.json()
}

export async function deleteGeneralConfig(id) {
    const resp = await fetch(apiUrl(`/api/admin/general-config/${id}`), {
        method: 'DELETE',
        headers: { ...getAuthHeader() }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to delete config')
}
